module.exports = __webpack_public_path__ + "static/media/license.279d0578.svg";